import script from "./TypicalPriceIndicator.vue?vue&type=script&lang=js"
export * from "./TypicalPriceIndicator.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__